import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export const withCredentialsInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const isApi: boolean = req.url.startsWith('/api/');

  if (!isApi) {
    return next(req);
  }

  return next(req.clone({ withCredentials: true }));
};
